import { colorsHsla } from '../../theme/colors';

export const customShadow = (color: any) => {
  return `${colorsHsla(color)} 0px 2px 4px 0px,${colorsHsla(
    color
  )} 0px 2px 8px 0px`;
};
